import { ClassNameMap } from '@mui/material';
import { ClassKeyOfStyles } from '@mui/styles';

// Types
import { TranslateFunction } from '../../../core/types/TypographyTypes';
// Utils
import COUNTRIES_ALL_DATA_JSON_EN from '../../../core/assets/CountriesList/countriesOptionAllData.en.json';
// Constants
import { BAP_ADD_TAX_COUNTRIES } from '../../../core/utils/Constants/Constants';

interface BecomePartnerFieldMappingParams {
    translate: TranslateFunction;
    classes: ClassNameMap<ClassKeyOfStyles<any>>;
    isDuplicateEmail: boolean;
}

export const getBecomePartnerFieldMappingDefinition = ({
    translate,
    classes,
    isDuplicateEmail
}: BecomePartnerFieldMappingParams) => {
    const becomePartnerFieldMappingDefinition = [
        {
            name: 'firstName',
            component: 'text',
            label: 'become.partner.form.firstname.label',
            additionalProps: { className: classes.formSectionInput, isCoralogixMasked:true }
        },
        {
            name: 'lastName',
            component: 'text',
            label: 'become.partner.form.lastname.label',
            additionalProps: { className: classes.formSectionInput, isCoralogixMasked:true }
        },
        {
            name: 'mobile',
            component: 'combo',
            label: 'become.partner.form.mobile.label',
            additionalProps: {
                className: classes.formSectionInput,
                type: 'dialing',
                countryCodeLabel: translate('become.partner.form.mobile.code.label'),
                isCoralogixMasked:true
            }
        },
        {
            name: 'companyName',
            component: 'text',
            label: 'become.partner.form.company.label',
            conditionalRender: (watch) => watch('customerType') === 'CFX',
            additionalProps: { className: classes.formSectionInput }
        },
        {
            name: 'country',
            component: 'select',
            label: 'address.lookup.country.label',
            options: COUNTRIES_ALL_DATA_JSON_EN.options,
            additionalProps: { className: classes.formSectionInput, type: 'country_excl' }
        },
        {
            name: 'taxNumber',
            component: 'text',
            label: 'become.partner.form.tax_number.label',
            conditionalRender: (watch) => BAP_ADD_TAX_COUNTRIES.includes(watch('country')),
            additionalProps: { className: classes.formSectionInput, isCoralogixMasked:true }
        },
        {
            name: 'businessCategory',
            component: 'select',
            label: 'become.partner.form.professionalCategory.label',
            additionalProps: { className: classes.formSectionInput, type: 'businessCategory' }
        },
        {
            name: 'duplicateEmailError',
            component: 'alertMessage',
            label: 'global.duplicate.error.title',
            conditionalRender: () => isDuplicateEmail,
            additionalProps: {
                className: 'errorMessage',
                title: translate("global.duplicate.error.title"),
                message: translate("global.duplicate.error.message"),
                link: '/login',
                linkText: translate("global.duplicate.error.link"),
                severity: "error",
                icon: 'error',
                hideCloseIcon: true,
                showLink: true
            }
        },
        {
            name: 'loginHeading',
            component: 'sectionHeading',
            label: 'become.partner.login.heading',
            additionalProps: {
                className: classes.formSectionHeading,
                variant: 'body1'
            }
        },
        {
            name: 'email',
            component: 'text',
            label: 'become.partner.form.email.label',
            additionalProps: {
                className: classes.formSectionInput,
                disabledAutoFill: 'new-email',
                isCoralogixMasked:true
            }
        },
        {
            name: 'password',
            component: 'text',
            label: 'become.partner.form.password.label',
            additionalProps: {
                className: classes.formSectionInput,
                disabledAutoFill: 'new-email',
                passwordCriteria: true,
                type: 'password',
                supportsUnmasking: true,
                isCoralogixMasked:true
            }
        }
    ];

    return becomePartnerFieldMappingDefinition;
}
